<app-report-html-page [pageBreak]="true">
    <div class="py-4 min-vh-100 d-flex flex-column justify-content-between" *ngIf="sourcesProvider">
        <div class="pt-3">
            <div class="row justify-content-center">
                <div class="col-8 col-md-5 col-lg-4">
                    <img [src]="logoPath" class="img-fluid d-block mx-auto" alt="Logo">
                </div>
            </div>
        </div>

        <div class="text-center mt-4 pt-3">
            <h1 class="display-5 fw-semibold mb-0">QUARTERLY REPORT</h1>
            <div class="fs-2 mt-3 notranslate">{{ quarterLabel }}</div>
        </div>

        <div class="text-center mt-4 pt-3">
            <div class="fs-2 notranslate" *ngIf="organisation?.name">{{ organisation?.name }}</div>
            <div class="mt-3">
                <div class="display-4 fw-normal text-info notranslate">{{ locationName }}</div>
                <div class="display-4 fw-normal text-info mt-2 notranslate">{{ locationAddress }}</div>
            </div>
        </div>

        <div class="row justify-content-center mt-3" *ngIf="locationImagePath">
            <div class="col-10 col-md-7 col-lg-6">
                <div class="ratio ratio-16x9 overflow-hidden rounded-3 border"
                     [style.background-image]="'url(' + locationImagePath + ')'"
                     [style.background-size]="'cover'"
                     [style.background-position]="'center'"
                     [style.background-repeat]="'no-repeat'"
                     role="img"
                     aria-label="Location image"></div>
            </div>
        </div>

        <div class="row justify-content-center" [ngClass]="locationImagePath ? 'mt-3' : 'mt-4 pt-3'">
            <div class="col-12 col-md-10 col-lg-9">
                <div class="bg-info-subtle border border-secondary-subtle rounded-4 p-3 p-md-4">
                    <div class="d-flex justify-content-between align-items-start gap-3 py-1" *ngIf="addressLine">
                        <span class="fw-bold">Address</span>
                        <strong class="fw-normal text-end notranslate">{{ addressLine }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-start gap-3 py-1" *ngIf="cityLine">
                        <span class="fw-bold">Postal code / city</span>
                        <strong class="fw-normal text-end notranslate">{{ cityLine }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-start gap-3 py-1" *ngIf="areaLabel">
                        <span class="fw-bold">Floor area</span>
                        <strong class="fw-normal text-end notranslate">{{ areaLabel }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-start gap-3 py-1" *ngIf="energyLabel">
                        <span class="fw-bold">Energy label</span>
                        <strong class="fw-normal text-end notranslate">{{ energyLabel }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-start gap-3 py-1" *ngIf="eanElectricity">
                        <span class="fw-bold">EAN code electricity</span>
                        <strong class="fw-normal text-end notranslate">{{ eanElectricity }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-start gap-3 py-1" *ngIf="eanGas">
                        <span class="fw-bold">EAN code gas</span>
                        <strong class="fw-normal text-end notranslate">{{ eanGas }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-start gap-3 py-1" *ngIf="eanHeat">
                        <span class="fw-bold">EAN code heat</span>
                        <strong class="fw-normal text-end notranslate">{{ eanHeat }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-start gap-3 py-1">
                        <span class="fw-bold">Reporting period</span>
                        <strong class="fw-normal text-end notranslate">{{ reportingWindowLabel }}</strong>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-report-html-page>
